import React, { useState } from "react"
import Image from "../components/image"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"
import VisibilitySensor from "react-visibility-sensor"

export default function ReadNext({ sectionID, pageID }) {
  const [loaded, setLoaded] = useState(false)
  const onChange = isVisible => {
    isVisible ? setLoaded(true) : setLoaded(false)
  }

  const menu = findObject(menuData, "id", sectionID)
  const content =
    menu && pageID ? findObject(menu.children, "id", pageID) : menu

  return (
    <div className="container container--max">
      <VisibilitySensor
        onChange={onChange}
        partialVisibility={true}
        offset={{ bottom: 75 }}
      >
        <Link
          className={`read-next ${
            loaded ? "read-next--show" : "read-next--hidden"
          }`}
          to={content.href}
        >
          <header>Read Next</header>
          <div className="read-next__inner">
            {content.thumbnail && (
              <Image
                path={content.thumbnail}
                alt={`Read next: ${content.name}`}
                className="read-next__image"
              />
            )}
            <div className="read-next__inner__content">
              <h4>{content.name}</h4>
              {content.deck && (
                <p className="read-next__deck">{content.deck}</p>
              )}
            </div>
          </div>
        </Link>
      </VisibilitySensor>
    </div>
  )
}
